import { SxProps } from "@mui/material";

export const sxOption: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  lineHeight: "24px",
};

export const sxTypographyAdvice: SxProps = {
  color: "#4C4C4C",
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "150%",
  letterSpacing: 'inherit !important'
};

export const sxTypographyAdviceBold: SxProps = {
  color: "#383838",
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "150%",
};

export const sxTypographyAdviceTitle: SxProps = {
  color: "#383838",
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "150%",
};

export const sxButtonText: SxProps = {
  textDecoration: "underline",
  textTransform: "none",
  fontFamily: "Unimed-Sans",
  fontWeight: 600,
  padding: 0,
  "&:hover": {
    color: "#164029",
  },
};

export const sxDivider: SxProps = {
  borderColor: "#EEEEEE",
};

export const sxButton: SxProps = {
  borderRadius: "80px",
  height: "44px",
  padding: "24px 32px"
};

export const sxTextButton: SxProps = {
  fontFamily: 'UnimedSans-Bold',
  fontSize: 16
};

export const sxOutlinedButton: SxProps = {
  fontFamily: "Unimed-Sans",
  borderRadius: "80px",
  border: "2px solid var(--Primary-01-Medium, #00995D)",
  padding: "12px 32px ",
};

export const sxModal: SxProps = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "481px",
  width: "85%",
  bgcolor: "#fff",
  borderRadius: "16px",
  border: "none",
  boxShadow: "0px 4px 100px 0px rgba(56, 56, 56, 0.20)",
  padding: "32px 48px",
  gap: "24px",
};

export const sxCloseIconButton: SxProps = {
  color: "#383838",
  "@media (max-width: 899px)": {
    height: "60px",
  },
};

export const sxCapitalize: SxProps = {
  textTransform: 'capitalize'
};

